// Isolated behind its own module so tests can mock the load without needing jsdom to
// support emoji-picker-element's browser-only dependencies (indexedDB, network fetch for
// emoji data) - same reasoning as @/helper.js's loadEcho.
export const loadEmojiPicker = () => import('emoji-picker-element')
